/* Creative Sukkah Signs — Shopify theme JS (replaces Webflow runtime) */
(function () {
  'use strict';

  /* ---------- helpers ---------- */
  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format
      .replace(/\{\{\s*amount\s*\}\}/, parts.join('.'))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','));
  }

  function qs(sel, el) { return (el || document).querySelector(sel); }
  function qsa(sel, el) { return Array.prototype.slice.call((el || document).querySelectorAll(sel)); }

  /* ---------- mobile nav ---------- */
  var navToggle = qs('[data-nav-toggle]');
  if (navToggle) {
    navToggle.addEventListener('click', function () {
      var nav = navToggle.closest('.navbar_component');
      nav.classList.toggle('nav-is-open');
      navToggle.classList.toggle('w--open');
    });
  }

  /* ---------- Shopify product variant artwork + SKU ---------- */
  qsa('[data-product-variant-picker]').forEach(function (picker) {
    var productHeader = picker.closest('.section_product-header');
    if (!productHeader) return;
    var choices = qsa('[data-variant-choice]', picker);
    var productImage = qs('[data-product-variant-image]', productHeader);
    var sku = qs('[data-product-variant-sku]', productHeader);
    var variantInput = qs('[data-product-variant-input]', productHeader);
    var customizerLink = qs('[data-customizer-link]', productHeader);
    var soldOut = qs('[data-product-variant-soldout]', productHeader);

    choices.forEach(function (choice) {
      choice.addEventListener('click', function () {
        var variantId = choice.getAttribute('data-variant-id');
        var variantTitle = choice.getAttribute('data-variant-title') || '';
        var variantImage = choice.getAttribute('data-variant-image') || '';
        var variantSku = choice.getAttribute('data-variant-sku') || '';
        var available = choice.getAttribute('data-variant-available') === 'true';

        choices.forEach(function (item) {
          var selected = item === choice;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        if (productImage && variantImage) {
          productImage.src = variantImage;
          productImage.removeAttribute('srcset');
          productImage.alt = variantTitle;
        }
        if (sku) sku.textContent = variantSku;
        if (variantInput) variantInput.value = variantId;
        if (customizerLink) {
          customizerLink.href = choice.getAttribute('data-customizer-url');
          customizerLink.setAttribute('aria-disabled', available ? 'false' : 'true');
        }
        if (soldOut) soldOut.hidden = available;
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variantId);
          window.history.replaceState(null, '', url.toString());
        }
      });
    });
  });

  /* Keep the customizer link dependable in Shopify theme preview, where
     editor scripts can occasionally swallow a normal anchor click. */
  qsa('[data-customizer-link]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      if (link.getAttribute('aria-disabled') === 'true') {
        event.preventDefault();
        return;
      }
      var destination = link.getAttribute('href');
      if (!destination) return;
      event.preventDefault();
      window.location.assign(destination);
    });
  });

  /* ---------- announcement banner ---------- */
  var announcementBanners = qsa('[data-banner]');
  var bannerWasShown = false;
  var visitStartedAt = Date.now();
  var announcementHideTimer;
  try {
    bannerWasShown = sessionStorage.getItem('creativeSukkahAnnouncementShown') === '1';
    var storedVisitStart = parseInt(sessionStorage.getItem('creativeSukkahVisitStartedAt'), 10);
    if (storedVisitStart) visitStartedAt = storedVisitStart;
    else sessionStorage.setItem('creativeSukkahVisitStartedAt', String(visitStartedAt));
  } catch (err) {}

  function hideAnnouncement() {
    announcementBanners.forEach(function (banner) { banner.classList.remove('is-popup-visible'); });
  }

  qsa('[data-banner-close]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      hideAnnouncement();
      window.clearTimeout(announcementHideTimer);
      try { sessionStorage.setItem('creativeSukkahAnnouncementShown', '1'); } catch (err) {}
    });
  });

  if (!bannerWasShown && announcementBanners.length) {
    var announcementDelay = Math.max(0, 10000 - (Date.now() - visitStartedAt));
    window.setTimeout(function () {
      announcementBanners.forEach(function (banner) {
        banner.classList.add('is-popup-visible');
      });
      try { sessionStorage.setItem('creativeSukkahAnnouncementShown', '1'); } catch (err) {}
      announcementHideTimer = window.setTimeout(hideAnnouncement, 5000);
    }, announcementDelay);
  }

  /* ---------- notice modal (once per session) ---------- */
  var noticeModal = qs('#notice-modal');
  if (noticeModal) {
    var noticeComponent = qs('.notice-modal_component', noticeModal);
    var seen = false;
    try { seen = sessionStorage.getItem('noticeSeen') === '1'; } catch (err) {}
    if (!seen && noticeComponent) noticeComponent.classList.add('is-visible');
    qsa('[data-notice-close]', noticeModal).forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        if (noticeComponent) noticeComponent.classList.remove('is-visible');
        try { sessionStorage.setItem('noticeSeen', '1'); } catch (err) {}
      });
    });
  }

  /* ---------- FAQ accordion ---------- */
  qsa('[data-faq]').forEach(function (item) {
    var question = qs('[data-faq-question]', item);
    var answer = qs('[data-faq-answer]', item);
    if (!question || !answer) return;
    question.style.cursor = 'pointer';
    question.addEventListener('click', function () {
      var isOpen = item.classList.contains('is-open');
      if (isOpen) {
        answer.style.height = '0px';
        item.classList.remove('is-open');
      } else {
        answer.style.height = answer.scrollHeight + 'px';
        item.classList.add('is-open');
      }
    });
  });

  /* ---------- product page tabs ---------- */
  qsa('[data-tabs]').forEach(function (tabs) {
    var links = qsa('[data-tab-link]', tabs);
    var panes = qsa('[data-tab-pane]', tabs);
    links.forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var target = link.getAttribute('data-tab-link');
        links.forEach(function (l) { l.classList.toggle('w--current', l === link); });
        panes.forEach(function (p) {
          p.classList.toggle('w--tab-active', p.getAttribute('data-tab-pane') === target);
        });
      });
    });
  });

  /* ---------- simple crossfade sliders ---------- */
  qsa('[data-slider]').forEach(function (slider) {
    var slides = qsa('[data-slide]', slider);
    if (slides.length < 2) { if (slides[0]) slides[0].classList.add('is-active'); return; }
    var nav = qs('[data-slider-nav]', slider);
    var current = 0;
    var timer = null;
    var autoplay = parseInt(slider.getAttribute('data-slider-autoplay') || '0', 10);

    var dots = [];
    if (nav) {
      slides.forEach(function (_, i) {
        var dot = document.createElement('div');
        dot.className = 'w-slider-dot' + (i === 0 ? ' w-active' : '');
        dot.style.cssText = 'width:10px;height:10px;border-radius:50%;margin:0 4px;display:inline-block;cursor:pointer;background:rgba(255,255,255,.5)';
        dot.addEventListener('click', function () { go(i); restart(); });
        nav.appendChild(dot);
        dots.push(dot);
      });
    }

    function go(i) {
      current = (i + slides.length) % slides.length;
      slides.forEach(function (s, j) { s.classList.toggle('is-active', j === current); });
      dots.forEach(function (d, j) {
        d.classList.toggle('w-active', j === current);
        d.style.background = j === current ? '#fff' : 'rgba(255,255,255,.5)';
      });
    }
    function restart() {
      if (!autoplay) return;
      clearInterval(timer);
      timer = setInterval(function () { go(current + 1); }, Math.max(autoplay, 2500));
    }
    var prev = qs('[data-slider-prev]', slider);
    var next = qs('[data-slider-next]', slider);
    if (prev) prev.addEventListener('click', function () { go(current - 1); restart(); });
    if (next) next.addEventListener('click', function () { go(current + 1); restart(); });
    go(0);
    restart();
  });

  /* ---------- featured products auto-scroll ---------- */
  qsa('[data-product-carousel]').forEach(function (carousel) {
    if (carousel.children.length < 2) return;
    var idx = 0;
    setInterval(function () {
      var items = carousel.children;
      if (!items.length) return;
      var firstItem = items[0];
      var carouselStyles = window.getComputedStyle(carousel);
      var gap = parseFloat(carouselStyles.columnGap || carouselStyles.gap) || 0;
      var itemWidth = firstItem.getBoundingClientRect().width;
      var visibleItems = Math.max(1, Math.round((carousel.clientWidth + gap) / (itemWidth + gap)));
      var lastFullPageStart = Math.max(0, items.length - visibleItems);
      idx = idx + visibleItems;
      if (idx > lastFullPageStart) idx = 0;
      var target = items[idx];
      var targetLeft = target.offsetLeft - firstItem.offsetLeft;
      carousel.scrollTo({ left: targetLeft, behavior: 'smooth' });
    }, 3500);
  });

  /* ---------- cart drawer ---------- */
  var cartDrawer = qs('[data-cart-drawer]');
  var cartCount = qs('[data-cart-count]');

  function openCart() {
    if (!cartDrawer) return;
    refreshCart().then(function () {
      cartDrawer.style.display = 'flex';
      document.documentElement.classList.add('cart-open');
    });
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.style.display = 'none';
    document.documentElement.classList.remove('cart-open');
  }

  qsa('[data-cart-open]').forEach(function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); openCart(); });
  });
  qsa('[data-cart-close]').forEach(function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); closeCart(); });
  });
  if (cartDrawer) {
    cartDrawer.addEventListener('click', function (e) {
      if (e.target === cartDrawer) closeCart();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeCart();
    });
  }

  function refreshCart() {
    return fetch((window.theme.routes.cart || '/cart') + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }

  function renderCart(cart) {
    var visibleItems = cart.items.filter(function (item) {
      return !(item.properties && item.properties['_Charge type']);
    });
    var visibleCount = visibleItems.reduce(function (total, item) {
      return total + item.quantity;
    }, 0);
    if (cartCount) {
      cartCount.textContent = visibleCount;
      cartCount.style.display = visibleCount > 0 ? '' : 'none';
    }
    var itemsEl = qs('[data-cart-items]');
    var formEl = qs('[data-cart-form]');
    var emptyEl = qs('[data-cart-empty]');
    var subtotalEl = qs('[data-cart-subtotal]');
    if (!itemsEl) return;

    if (cart.item_count === 0) {
      if (formEl) formEl.style.display = 'none';
      if (emptyEl) emptyEl.style.display = '';
      itemsEl.innerHTML = '';
      return;
    }
    if (formEl) formEl.style.display = '';
    if (emptyEl) emptyEl.style.display = 'none';
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.items_subtotal_price);

    itemsEl.innerHTML = visibleItems.map(function (item, i) {
      var props = '';
      if (item.properties) {
        Object.keys(item.properties).forEach(function (k) {
          if (k.charAt(0) !== '_' && item.properties[k]) {
            props += '<div style="font-size:.85em;opacity:.75">' + k + ': ' + item.properties[k] + '</div>';
          }
        });
      }
      return (
        '<div class="w-commerce-commercecartitem" style="display:flex;gap:.75rem;padding:.75rem 0;border-bottom:1px solid rgba(0,0,0,.06)">' +
          '<img src="' + ((item.properties && item.properties['_Source image']) || item.image || '') + '&width=120" alt="" style="width:60px;height:60px;object-fit:cover;border-radius:4px" onerror="this.style.display=\'none\'">' +
          '<div style="flex:1;min-width:0">' +
            '<div style="font-weight:600">' + ((item.properties && item.properties.Artwork) || item.product_title) + '</div>' +
            props +
            '<div style="font-size:.85em;opacity:.75">Qty ' + item.quantity + ' × ' + formatMoney(item.price) + '</div>' +
            '<a href="#" data-cart-visible-index="' + i + '" style="font-size:.85em;text-decoration:underline">Remove</a>' +
          '</div>' +
          '<div style="font-weight:600">' + formatMoney(item.final_line_price) + '</div>' +
        '</div>'
      );
    }).join('');

    qsa('[data-cart-visible-index]', itemsEl).forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var item = visibleItems[parseInt(link.getAttribute('data-cart-visible-index'), 10)];
        if (!item) return;
        var designId = item.properties && item.properties['_Design ID'];
        var updates = {};
        cart.items.forEach(function (cartItem) {
          if (designId && cartItem.properties && cartItem.properties['_Design ID'] === designId) updates[cartItem.key] = 0;
        });
        if (!designId) updates[item.key] = 0;
        fetch(window.theme.routes.cartUpdate + '.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function (r) { return r.json(); }).then(renderCart);
      });
    });
  }

  /* ---------- product: "customize your sign here" = buy now → checkout ---------- */
  var buyNowButton = qs('[data-buy-now]');
  var productForm = qs('[data-product-form]');
  if (buyNowButton && productForm) {
    var errorEl = qs('[data-add-to-cart-error]');

    buyNowButton.addEventListener('click', function (e) {
      e.preventDefault();
      if (buyNowButton.getAttribute('aria-disabled') === 'true') return;
      if (errorEl) errorEl.style.display = 'none';
      var originalLabel = buyNowButton.textContent;
      buyNowButton.textContent = 'One moment...';
      buyNowButton.style.pointerEvents = 'none';

      // Send the whole product form (includes any fields injected by customizer apps),
      // then go straight to Shopify checkout.
      fetch(window.theme.routes.cartAdd, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(productForm)
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (j) { throw j; });
          return r.json();
        })
        .then(function () {
          window.location.href = (window.theme.routes.cart || '/cart') + '/checkout';
        })
        .catch(function (err) {
          buyNowButton.textContent = originalLabel;
          buyNowButton.style.pointerEvents = '';
          if (errorEl) {
            errorEl.style.display = 'block';
            errorEl.firstElementChild.textContent = (err && err.description) || 'Something went wrong. Please try again.';
          }
        });
    });
  }
})();
